import store from "../store";

export const CanDirective = {
  bind(el, binding) {
    if (false === store.getters["userStoreModule/canAccess"](binding.value)) {
      el.innerText = "";
    }
  },
};
